import React from 'react';
import HousekeepingLogErrors from '../HousekeepingLogErrors';
import RoomDetails from '../../ReservationSegmentCard/tabs/RoomDetails';
import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import TimePickerInput from '../../TimePickerInput/TimePickerInput';
import DateHelper from '../../DateHelper/DateHelper';
import clsx from "clsx";
import { format, isSameDay } from 'date-fns';

export default class HousekeepingLogGeneral extends React.Component{
  constructor(props) {
    super(props);
    this.onChangeRoomType = this.onChangeRoomType.bind(this)
    this.onChangeScheduledAt = this.onChangeScheduledAt.bind(this)
    this.renderFieldClasses = this.renderFieldClasses.bind(this)
    this.onChangeStartTime = this.onChangeStartTime.bind(this);
    this.onChangeEndTime = this.onChangeEndTime.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        {this.renderGeneralForm()}
      </div>
    );
  }


  renderGeneralForm() {
  
    var reservation_segment = null
    if (!this.props.reservation_segment && this.props.room && this.props.room.reservation_segment){
      // reservation_segment = this.props.room.reservation_segment
    } else if (!this.props.reservation_segment && this.props.room_group && this.props.room_group.reservation_segment) {
      // reservation_segment = this.props.room_group.reservation_segment
    } else if (this.props.reservation_segment) {
      // reservation_segment = this.props.reservation_segment
      var check_in_date = this.props.reservation_segment.check_in_date;
      var today = new Date()

      var check_in_today = isSameDay(this.props.reservation_segment.check_in_date, today) && this.props.reservation_segment.status != "checked_in"
      var check_out_today = isSameDay(this.props.reservation_segment.check_out_date, today) && this.props.reservation_segment.status == "checked_in"
    }
    
    var room = null
    if (this.props.room) {
      room = this.props.room
    } else if (this.props.room_group) {
      room = this.props.room_group
    }
    
    return (
      <div>
        <div className="row" style={{marginBottom: 15}}>
          <div className="col-sm-4 form-group">
            <label>{I18n.t('scheduled_date')}</label>
            <br />
            {
              this.props.read_only 
              ?
              <div>
                {format(this.props.scheduled_at, DateHelper.rubyToDateFNS(this.props.dateFormat))}
                {
                  this.props.startTime && this.props.endTime
                  ? 
                  <p>Between {DateHelper.printDateToScreen(new Date(this.props.startTime), this.props.time_format, true)} and {DateHelper.printDateToScreen(new Date(this.props.endTime), this.props.time_format, true)} </p>
                  : null
                }
              </div>
              :
              <div> 
                <DatePickerInput 
                  selectedDate={this.props.scheduled_at} 
                  onChange={this.onChangeScheduledAt} 
                  dateFormat={this.props.date_format} 
                />   
                <a className="time-expand" onClick={() => this.props.onChangeTime(this.props.setTimeOpen ? false : true, 'setTimeOpen')}>{I18n.t('set_time')} {this.props.setTimeOpen ? <span className="toggle-arrow arrow-down"></span> : <span className="toggle-arrow arrow-right"></span>} </a>
              </div>
            }

            <div className="row">
              {
                this.props.setTimeOpen && !this.props.read_only
                ?
                <>
                  <div className="col-sm-6">
                    <label>{I18n.t('between')}</label>
                    <br />
                    
                    <TimePickerInput 
                      format={this.props.time_format}
                      selectedTime={this.props.startTime ? this.props.startTime : null} 
                      onChange={this.onChangeStartTime} 
                    />
                  </div>
                  <div className="col-sm-6">
                    <label>{I18n.t('and')}</label>
                    
                    <TimePickerInput 
                      format={this.props.time_format}
                      selectedTime={this.props.endTime ? this.props.endTime : null} 
                      onChange={this.onChangeEndTime} 
                    />
                  </div>
                </>
                : 
                null
              }
            </div>
       
          </div>
          {this.props.request_cleaning === false ?
            <div className="col-sm-4  form-group">
              <label>{I18n.t('status')}</label>
              <br />
              {
                this.props.read_only ?
                  I18n.t(this.props.status || 'none') :
                  <select className="form-control" value={this.props.status} name="status" onChange={this.props.onChange}>
                    <option value="submitted">{I18n.t('submitted')}</option>
                    <option value="acknowledged">{I18n.t('acknowledged')}</option>
                    <option value="started">{I18n.t('started')}</option>
                    <option value="finished">{I18n.t('finished')}</option>
                    <option value="missed">{I18n.t('missed')}</option>
                  </select>
              }
            </div> : null
          }
        </div>

        <div className="row">
          {this.props.housekeeping_type && this.props.housekeeping_type.name
          ?
          <div className="col-md-6 RoomDetails">
            <div className="panel panel-default">
              <div className="panel-heading flexed">
                <div className="col-md-6 panel-title-wrapper">
                  <h3 className="panel-title" >{this.props.housekeeping_type.name}</h3>
                </div>
              </div>
              <div className="panel-body container">
                {this.props.housekeeping_type.description
                ?
                <div dangerouslySetInnerHTML={{__html:this.props.housekeeping_type.description}}></div>
                :
                <span className="none">{I18n.t('none')}</span>
                }
              </div>
            </div>
          </div>
          :
          null
          }
          {!this.props.new_record && this.props.reservation_segment 
          ?
          <RoomDetails {...this.props} check_in_date={check_in_date} today={today} check_in_today={check_in_today} check_out_today={check_out_today} read_only={true}/>
          :
          null
          }
        </div>
      </div>
    );
  }


  onChangeRoomType(room_type) {
    this.props.onChangeRoomType(room_type);
  }

  onChangeScheduledAt(date) {
    this.props.onChangeTime(date, 'scheduled_at');
  };

  onChangeStartTime(time) {
    this.props.onChangeTime(time, 'startTime');
  };

  onChangeEndTime(time) {
    this.props.onChangeTime(time, 'endTime');
  };


  renderErrors() {
    var errors = HousekeepingLogErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classname) {

    var classname = classname || '';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

};
